/**
 * AUTO-GENERATED by scripts/sync-home-showcase-light-manifest.mjs
 * Do not edit by hand. Re-run: npm run sync:showcase-light-manifest --workspace apps/web
 *
 * Keys are asset basenames (e.g. map-light-en) for files in public/images/scan/.
 */
export const HOME_SHOWCASE_LIGHT_AVAILABLE = new Set<string>([
  "alerts-light-en",
  "map-light-en",
  "menu-light-en",
  "share-light-en",
]);
